import type { GetProjects200PageAllOfThreeContentItem } from './getProjects200PageAllOfThreeContentItem';

export type GetProjects200PageAllOfThree = {
  /** 프로젝트 목록 */
  content?: GetProjects200PageAllOfThreeContentItem[];
};
